import { useHost, XingletLoaderProps } from '@xing-com/crate-xinglet';

type LinkShareXingletLoaderProps = XingletLoaderProps & {
  linkShareGlobalId?: string;
  contextGlobalId?: string;
  onPublishCallback: (canRefetchArticlesList: boolean) => void;
  setIsFormDirty: (isFormDirty: boolean) => void;
  setCanRefetchArticlesList(canRefetchArticlesList: boolean): void;
  onDialogChange(showPublishDialog: boolean): void;
};

export const LinkShareXingletLoader: React.FC<LinkShareXingletLoaderProps> = (
  props
) => {
  const host = useHost();

  return <host.XingletLoader {...props} />;
};
